export default {
    //英语
    DiagnosticReport:'Diagnostic report',
    troubleCode:'Fault code',
    time:'time',
    noTItle:'Manufacturer control',
    TestReport:'Test Report',
    VehicleInformation:'Vehicle Information',
    DataStream:'Data stream',
    IMReadiness:'I/M Readiness',
    Communication:'Communication protocol',
    notFaultCode:'No fault code',
    nodataflow:'No abnormal data flow',
    // 语言
    lang:{
        cn:'Chinese',
        de:'German',
        en:'English',
        es:'Spanish',
        fr:'French',
        it:'Italian',
        ja:'Japanese',
        ko:'Korean',
        pt:'Portuguese'
    }
}